<template>
  <div class="ml-0 mr-0 mt-0">
    <div class="is-flex">
      <b-taglist attached class="m-0 p-0 ml-auto">
        <b-tag type="is-dark">Version</b-tag>
        <b-tag type="is-info">
          {{
            selectedDevice.chartsData && selectedDevice.chartsData.querySet ? selectedDevice.chartsData.querySet.veh.version : 'unknown'
          }}
        </b-tag>
      </b-taglist>
    </div>
    <div>
      <div class="is-flex is-flex-direction-row mt-0 pt-0">
        <div class="mt-auto mb-auto pt-0">
            <b-select v-model="selectedDate" placeholder="Select date...">
              <option v-for="date in dates" :key="date" :value="date">
                {{ date }}
              </option>
            </b-select>
        </div>
        <div class="mt-0 pt-0 is-flex ml-6">
            <b-radio class="mt-auto mb-auto" v-for="dir in directions" :key="dir" v-model="selectedDirection" :native-value="dir">
              {{ dir }}
            </b-radio>
        </div>
      </div>
      <apex-chart v-if="chartOptions" type="line" height="292" :options="chartOptions" :series="chartSeries"></apex-chart>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
export default {
  name: "speed15-chart",
  data() {
    return {
      selectedDate: null,
      selectedDirection: null,
    }
  },
  mounted() {
    console.log('Today: ', new Date().toISOString())
    console.log('Selected device: ', this.selectedDevice)
  },
  methods: {},
  computed: {
    ...mapGetters({
      selectedDevice: 'qaModule/getSelectedQaDevice'
    }),
    chartData() {
      if (this.selectedDevice && this.selectedDevice.chartsData) {
        return this.selectedDevice.chartsData
      }
      return null
    },
    dates() {
      console.log('Charts data: ', this.chartData)
      if (!this.chartData || !this.chartData.vehSpeed15minsChart) return [];
      return Object.keys(this.chartData.vehSpeed15minsChart);
    },
    directions() {
      if (!this.selectedDate || !this.chartData || !this.chartData.vehSpeed15minsChart) return [];
      const dirs =  Object.keys(this.chartData.vehSpeed15minsChart[this.selectedDate].data);
      console.log('Directions: ', dirs)
      return dirs
    },
    chartSeries() {
      if (!this.selectedDate || !this.chartData || !this.selectedDirection) return [];

      const datasets = this.chartData.vehSpeed15minsChart[this.selectedDate].data[this.selectedDirection];
      return datasets.map(ds => ({
        name: ds.name,
        data: ds.y
      }));
    },
    chartOptions() {
      if (!this.selectedDate || !this.chartData || !this.selectedDirection) return {};

      const datasets = this.chartData.vehSpeed15minsChart[this.selectedDate].data[this.selectedDirection];
      const categories = datasets[0].x;

      return {
        chart: {id: "speed-chart", animations: {enabled: true}, fontFamily: 'Barlow',},
        stroke: {curve: "straight", width: 3},
        xaxis: {categories},
        yaxis: {title: {text: "Speed (km/h)"}},
        tooltip: {shared: true},
        markers: {size: 3}
      };
    }
  },
  watch:{
    selectedDate: {
      handler: function (after, before) {
        if(this.directions.length > 0){
          this.selectedDirection = this.directions[0]
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>

</style>